import $ from 'jquery';
import 'slick-carousel';
import Modal from './modal';
import getLayout from './get-modal-layout';

class ModalFlats extends Modal {
  constructor() {
    super();
    this.controls = [...this.page.querySelectorAll(`.flats__pictures .screen-pictures__control`)];
    this.slider = null;
  }

  init() {
    super.createModal();
    this.createSlider();
    this.bindHandlers();
  }

  createSlider() {
    const sliderLayout = getLayout(`flats`);

    super.addLayout(sliderLayout);
    this.slider = this.page.querySelector(`#modal-flats`);
    this.initSlider();
  };

  initSlider() {
    $(this.slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true
    });
  }

  bindHandlers() {
    //put handlers for landings here
  }
}

const modalFlats = new ModalFlats();

export default modalFlats;
